/**
 * @generated SignedSource<<0e1178673d371eff4f0ed49a124404a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultAuthorCardAuthor$data = {
  readonly " $fragmentSpreads": FragmentRefs<"authorAvatarAuthor" | "authorBioAuthor" | "authorNameAuthor" | "authorRoleAuthor" | "entityFollowButtonBase" | "followButtonBase">;
  readonly " $fragmentType": "defaultAuthorCardAuthor";
};
export type defaultAuthorCardAuthor$key = {
  readonly " $data"?: defaultAuthorCardAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"defaultAuthorCardAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "defaultAuthorCardAuthor",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorAvatarAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorBioAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorNameAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorRoleAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "followButtonBase"
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "d0a919c6beb4fc522e5ceb936c6d423e";

export default node;
